import Request from '../request';
import {
  V2MeetingExtendForm,
  V2MeetingExtendResponse,
  V2MeetingRecommendForm,
  V2MeetingRecommendResponse
} from './interface';

const request = new Request('meeting');

export const extendMeeting = <T = unknown>(meetingNo: string, data: V2MeetingExtendForm) => {
  return request.post<V2MeetingExtendResponse<T>>(`/api/user/v2/meetings/${meetingNo}/actions/extend`, data);
};

export const recommendMeeting = (data: V2MeetingRecommendForm) => {
  return request.post<V2MeetingRecommendResponse>('/api/user/v2/meetings/actions/recommend', data);
};

export * from './interface';
